import { FC } from 'react';
import { Datagrid, DateField, List, TextField } from 'react-admin';

export const HistoryList: FC = () => (
  <List title="История запросов" filter={{}} actions={false}>
    <Datagrid>
      <TextField source="id" label="ID" />
      <TextField source="request" label="Запрос" />
      <TextField source="response" label="Ответ" />
      <TextField source="username" label="username" />
      <DateField source="request_at" label="Создан" locales={['ru']} />
      <DateField source="response_at" label="Изменен" locales={['ru']} />
    </Datagrid>
  </List>
);
